type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const StarIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.7497 4.66724L28.5533 16.4247L41.5316 18.3217L32.1406 27.4685L34.3569 40.3904L22.7497 34.2863L11.1425 40.3904L13.3587 27.4685L3.96777 18.3217L16.9461 16.4247L22.7497 4.66724Z"
        stroke={color}
        strokeWidth="3.75638"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
